import * as React from "react";

import "@vwfs-bronson/bronson-bluelabel/dist/css/style.min.css";

const index = ({ children }) => <>{children}</>;

export default index;
